import {
  View,
  Image,
  useWindowDimensions,
  ImageStyle,
  ViewStyle,
  TextStyle,
} from 'react-native';
import React from 'react';
import {Button} from 'ui-kits';

import {staticDataForScreen} from 'constants/DefaultValues';
const NAVS = staticDataForScreen.landing_screen.heroSection.nav;

type propType = Readonly<{
  nagivateToLogin: () => void;
}>;

export function Navbar({nagivateToLogin}: propType): JSX.Element {
  // responsive ness implementation
  const {width: SCREEN_WIDTH} = useWindowDimensions();

  let overridestyle = structuredClone(styles);

  if (SCREEN_WIDTH < 1024) {
    overridestyle.image.width = 111;
    overridestyle.image.height = 66;
  }
  if (SCREEN_WIDTH < 720) {
    overridestyle.image.width = 96;
    overridestyle.image.height = 57;
  }
  if (SCREEN_WIDTH < 640) {
    overridestyle.image.width = 81;
    overridestyle.image.height = 48;
  }
  if (SCREEN_WIDTH < 480) {
    overridestyle.image.width = 66;
    overridestyle.image.height = 39;
  }

  // required keyword used for typescript
  const logo = require('assets/images/logo.png');

  return (
    <View style={styles.navbar}>
      <Image style={[styles.image, overridestyle.image]} source={logo} />

      {/* will be added later on */}
      {/* <View style={styles.navlinks}>
      {NAVS.map(
        (item) => (
          <Text style={styles.navLinkLabel} key={item.id}>
            {item.label}
          </Text>
        ),
      )}
    </View> */}
      {/* <Button
        style={styles.loginButton}
        variant="outline"
        text="Login"
        onPress={nagivateToLogin}
      /> */}
    </View>
  );
}

type styleType = {
  image: ImageStyle;
  navbar: ViewStyle;
  auth: ViewStyle;
  navlinks: ViewStyle;
  navLinkLabel: TextStyle;
  loginButton: ViewStyle;
};

const styles: styleType = {
  image: {
    width: 127,
    height: 74,
  },
  loginButton: {
    maxWidth: 100,
  },
  navbar: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  auth: {},
  navlinks: {
    flexDirection: 'row',
  },
  navLinkLabel: {
    color: 'white',
  },
};
